// Lightweight inline SVG icon set — no external icon library required.

const paths = {
  truck: (
    <>
      <path d="M1 7h11v9H1z" />
      <path d="M12 10h4l4 3.5V16h-8z" />
      <circle cx="5" cy="18" r="1.8" />
      <circle cx="16.5" cy="18" r="1.8" />
    </>
  ),
  warehouse: (
    <>
      <path d="M2 10.5 12 4l10 6.5V20H2z" />
      <path d="M9 20v-6h6v6" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.6 3.8 5.7 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.7-3.8-9S9.5 5.6 12 3Z" />
    </>
  ),
  route: (
    <>
      <circle cx="5" cy="6" r="2.2" />
      <circle cx="19" cy="18" r="2.2" />
      <path d="M5 8.2V13a4 4 0 0 0 4 4h6" />
    </>
  ),
  package: (
    <>
      <path d="M3 7.5 12 3l9 4.5-9 4.5-9-4.5Z" />
      <path d="M3 7.5V16l9 4.5 9-4.5V7.5" />
      <path d="M12 12v8.5" />
    </>
  ),
  shield: (
    <path d="M12 3 4 6v6c0 4.6 3.2 8.4 8 9 4.8-.6 8-4.4 8-9V6l-8-3Z" />
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5.5l4 2" />
    </>
  ),
  headset: (
    <>
      <path d="M4 13v-1a8 8 0 0 1 16 0v1" />
      <rect x="2.5" y="13" width="4.5" height="6" rx="1.5" />
      <rect x="17" y="13" width="4.5" height="6" rx="1.5" />
      <path d="M19.5 19.3v.7a3 3 0 0 1-3 3h-3.2" />
    </>
  ),
  map: (
    <>
      <path d="M9 4 3 6.5v13L9 17l6 2.5 6-2.5v-13L15 6.5 9 4Z" />
      <path d="M9 4v13M15 6.5V19.5" />
    </>
  ),
  menu: (
    <path d="M3 6h18M3 12h18M3 18h18" />
  ),
  close: (
    <path d="M6 6l12 12M18 6L6 18" />
  ),
  phone: (
    <path d="M5 4h3.2l1.3 4.4-2 1.6a12 12 0 0 0 6.5 6.5l1.6-2 4.4 1.3V19a2 2 0 0 1-2.2 2A16 16 0 0 1 3 5.2 2 2 0 0 1 5 4Z" />
  ),
  mail: (
    <>
      <rect x="2.5" y="5" width="19" height="14" rx="2" />
      <path d="m3.5 6.5 8.5 6.5 8.5-6.5" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s7-6.5 7-12a7 7 0 0 0-14 0c0 5.5 7 12 7 12Z" />
      <circle cx="12" cy="9" r="2.5" />
    </>
  ),
  check: (
    <path d="m5 12.5 4.5 4.5L19 7" />
  ),
  star: (
    <path d="m12 3 2.7 5.9 6.3.6-4.8 4.3 1.4 6.2L12 17l-5.6 3 1.4-6.2-4.8-4.3 6.3-.6L12 3Z" />
  ),
  arrowRight: (
    <path d="M4 12h15M13 6l6 6-6 6" />
  ),
  facebook: (
    <path d="M14 9h3V5.5h-3c-2.2 0-4 1.8-4 4V12H8v3.5h2V22h3.5v-6.5H16l.5-3.5h-3v-2c0-.6.4-1 1-1Z" />
  ),
  twitter: (
    <path d="M21 5.8c-.7.3-1.5.5-2.2.6a3.9 3.9 0 0 0 1.7-2.1c-.8.4-1.6.8-2.5 1a3.8 3.8 0 0 0-6.5 3.5A11 11 0 0 1 3.4 4.6a3.9 3.9 0 0 0 1.2 5.2c-.6 0-1.2-.2-1.7-.5v.1c0 1.9 1.3 3.4 3.1 3.8a3.9 3.9 0 0 1-1.7.1 3.8 3.8 0 0 0 3.6 2.7A7.7 7.7 0 0 1 2 17.5a11 11 0 0 0 5.9 1.7c7.1 0 11-5.9 11-11v-.5c.8-.5 1.4-1.2 2.1-2Z" />
  ),
  linkedin: (
    <>
      <rect x="3" y="9" width="4" height="12" />
      <circle cx="5" cy="5" r="2.3" />
      <path d="M11 9h3.8v1.8h.1c.5-1 1.8-2 3.7-2 4 0 4.7 2.4 4.7 5.6V21H19v-6c0-1.4 0-3.3-2-3.3s-2.4 1.6-2.4 3.2V21H11V9Z" />
    </>
  ),
  instagram: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" />
    </>
  ),
};

export default function Icon({ name, className = "w-6 h-6", strokeWidth = 1.8 }) {
  const content = paths[name];
  if (!content) return null;

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {content}
    </svg>
  );
}
